// @flow

// Libs
import _filter from 'lodash/filter'
import _isEmpty from 'lodash/isEmpty'
import { createSelector } from 'reselect'

// Utils
import traverse from 'fc-utils/traverse'
import extent from 'turf-extent'

// Selectors
import { assets$ } from 'fc-assets'

// Types
import type {
  AssetsById,
  Asset,
} from 'fc-model-assets/types'

// Constants
import {
  PROP_SHAPE,
  PROP_PARENT,
  PROP_SEASON,
} from 'fc-model-assets'
import {
  PROP_SHAPE_DATA,
  PROP_FEATURES,
} from 'fc-model-shapes'
import { FEATURECOLLECTION } from 'fc-utils/geoJson'

export default function getFarmBboxById ({ seasonId, farmId }: { seasonId: number, farmId: number }): Function {
  return createSelector(
    [ assets$ ], (assets: AssetsById): Array => {
      const fieldsOfCurrentFarmAndSeason: Array = _filter(assets, (asset: Asset): boolean =>
        asset[PROP_PARENT] === farmId && asset[PROP_SEASON] === seasonId
      )
      const fieldsWithShape = fieldsOfCurrentFarmAndSeason.filter((field: Asset): boolean => !!field[PROP_SHAPE])
      let fieldsFeatures = fieldsWithShape.map((field: Asset): Array<Asset> => (
        {
          ...traverse([PROP_SHAPE, PROP_SHAPE_DATA, PROP_FEATURES, 0], {default: {}})(field),
        })
      )
      fieldsFeatures = _filter(fieldsFeatures, (feature: Object): boolean => !_isEmpty(feature))

      if (fieldsFeatures.length) {
        const fieldFeatureCollection = {
          type: FEATURECOLLECTION,
          features: fieldsFeatures,
        }

        const [y1, x1, y2, x2] = extent(fieldFeatureCollection)

        return [[x1, y1], [x2, y2]]
      }

      return []
    }
  )
}
